import {OwnershipDocument} from "../models/OwnershipDocument";
import {PreviewOwnershipDocumentTemplateData} from "./PreviewOwnershipDocumentTemplateData";
import {PreviewOwnershipDocumentImportTemplate} from "./PreviewOwnershipDocumentImportTemplate";
import {cloneDeep} from "lodash";

export const getPreviewOwnershipDocumentTemplate = (
    documentsOfImport: OwnershipDocument[],
    selectedWarehouse: string,
    selectedProduct: string,
    selectedProductCategory: string,
    dateFrom: Date,
    dateTo: Date
    ) => {
    return PreviewOwnershipDocumentImportTemplate(prepareData(
        documentsOfImport.sort((a: OwnershipDocument, b: OwnershipDocument) => {
            return (new Date(a?.date as Date)).getTime() < (new Date(b?.date as Date)).getTime() ? 1 : -1}),
        selectedWarehouse,
        selectedProduct,
        selectedProductCategory,
        dateFrom,
        dateTo
    ));
};

const prepareData = (
    documentsOfImport: OwnershipDocument[],
    selectedWarehouse: string,
    selectedProduct: string,
    selectedProductCategory: string,
    dateFrom: Date,
    dateTo: Date
    ) => {
    const templateData: PreviewOwnershipDocumentTemplateData = {
        documentsOfImport: cloneDeep(documentsOfImport),
        selectedWarehouse: selectedWarehouse ? ` u magacinu ${selectedWarehouse}` : ' za sve magacine',
        selectedProduct: selectedProduct ?? '',
        selectedProductCategory: selectedProductCategory != '' ? `proizvod ${selectedProductCategory}` : 'sve kategorije proizvoda',
        dateFrom: dateFrom,
        dateTo: dateTo
    };

    return templateData;
};